<template>
  <!--    首页单屏-->
  <div class="banner">
    <div class="cover">
      <div class="cover-text">
        <div class="main">{{ $t("xwzx") }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.cover {
  position: relative;
  width: 100%;
  height: 30rem;
  min-height: 30rem;
  overflow: hidden;
  background: url("~@/assets/images/newsCenter/banner.png") no-repeat top;
  background-size: cover;
  /* &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(
      180deg,
      #030f21 0%,
      rgba(3, 15, 33, 0.9) 12%,
      rgba(4, 9, 20, 0.2) 63%,
      rgba(3, 14, 32, 0.7) 91%,
      #030f21 100%
    );
  } */
}
.cover-text {
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  color: #fff;
  text-align: center;
  transform: translate(-50%, -50%);

  .main {
    font-size: 2.1rem;
    font-weight: bold;
    color: #ffffff;
    letter-spacing: 2px;
  }
}
</style>
